export default {
  courses: [
    {
      id: '792886ce-408b-4d58-bc45-beced752fce8',
      title: 'Node Js',
      description: `Olá, seja muito bem vindo a Formação Node.js, meu nome é Victor Lima(CEO do Guia do programador), e eu serei seu instrutor durante todo este curso.
      Eu criei essa formação para ser o que eu gostaria de ter estudado quando eu estava aprendendo Node.js
      A Formação Node.js, é um curso completo que vai do básico do Node.js, se aprofundado bastante no desenvolvimento web com Javascript para o back-end, com bibliotecas como Express.js, e bancos de dados como MongoDB e MySQL.
      Toda a Formação Node.js, tem um único objetivo: Transformar você em um desenvolvedor Node completo, que é capaz de desenvolver, testar e fazer deploy de aplicações reais.
      A Melhor forma de aprender Node.js é construindo aplicações na prática.
      E é por esse motivo, que na nossa formação vamos ter muitos projetos práticos que serão ensinados do zero.
      Desde o inicio do curso você vai estar com a mão na massa, desenvolvendo todos os tipos de projetos web com o Node.js e Javascript. Isso vai te dar experiência prática necessária para desenvolver seus próprios projetos.
      Você vai aprender a construir vários projetos:
      · [Projeto #01] Criando uma plataforma de perguntas e respostas
      · [Projeto #02] Criando um blog com Express.js e MySQL
      Após desenvolver todos esses projetos, você vai ser capaz de desenvolver qualquer tipo de aplicação web com Node.js e Javascript.
      Tudo o que você precisa em um único curso
      Com a formação Node.js, você vai aprender TODAS as habilidades essenciais para construção de qualquer aplicação web real. Tudo em um único curso.
      É o melhor momento para aprender Node.js
      Segunda uma pesquisa do Stackoverflow, Node.js está entre as 3 tecnologias back-end mais populares do mundo. Com muitas vagas de empregos disponíveis, com salários que chegam até 10.000 R$ por mês.`,
      lessons: [
        { id: '20829bff-8872-498e-8c3e-028de3441de6', title: 'Node.js' },
        { id: 'b3128013-4568-4bc8-8e3b-3a84c5881ede', title: 'ES6/ES7' },
        { id: '226e4f4c-656a-41ef-8f44-f82c3d89545c', title: 'Express.js' },
        { id: 'a6095646-bfc8-4b82-b6db-44fc7fb60196', title: 'MySQL' },
        { id: 'eeb60f67-34fb-4eaa-8724-1669d032ca7a', title: 'MongoDB' },
        { id: '6a0394f5-e26b-4463-8160-7ed7d99b2bbc', title: 'Mongoose' },
        { id: '39cacba1-2b97-4a84-8374-3a17915a27cc', title: 'Socket io' },
        { id: '2ac35a62-d733-4a65-a9ef-a79a75e83ac5', title: 'REST' },
        { id: '3dd45eab-90bb-45a5-bfbd-bfce5d394e21', title: 'TDD' }
      ]
    },
    {
      id: '228207ec-5031-4ac9-b5fc-f5a3dfa9e6d4',
      title: 'PHP',
      description:
        'Este Curso de PHP 7 Completo vai proporcionar em um só lugar tudo o que precisa saber para criar seu próprio website. A equipe de instrutores da Hcode estará disponível para responder suas dúvidas. ',
      lessons: [
        { id: '381d1a5e-6ecd-430b-852f-731de41c3010', title: 'Instalação' },
        { id: 'd7c03317-1d4f-492c-b6b6-f643dfcc4b16', title: 'Variáveis' },
        { id: 'cd3b6198-38c9-43cf-8ecf-757069459b27', title: 'lessons' },
        { id: '249031ad-f574-49da-89a9-337d8954faf8', title: 'Objetos' },
        { id: '0e5d0f2e-6548-4765-a050-27ec18fbafea', title: 'Conclusão' }
      ]
    },
    {
      id: '5ea03f66-d796-475a-a5ff-4630b34c5546',
      title: 'Vue JS',
      description: `VueJS é um Framework JavaScript Progressivo (adotado incrementalmente) para a construção de interfaces do usuário.
      Se tornou extremamente popular pela sua habilidade de mesclar simplicidade e performance!
      Com uma curva de aprendizado muito baixa, Vue entrega ao desenvolvedor as ferramentas essenciais a qualquer projeto, seja ele de pequeno até grandeporte a nível empresarial, e tudo o que você precisa saber é JavaScript, nada mais!
      Vagas de emprego que demandam conhecimento em Frameworks como o VueJS estão em alta e entre as mais bem pagas do mercado, e este é o momento perfeito para você conhecê-lo e em detalhes!
      Venha comigo e vamos fazer uma incrível viagem ao mundo do VueJS!`,
      lessons: [
        { id: 'f4b28d03-c505-4bed-bdbd-6c4863b44b18', title: 'Front-end' },
        { id: '9d685172-b6db-4308-876b-3f41f88e14f4', title: 'Instalação' },
        { id: '727b6d6e-36ba-4fee-8fac-2b38865ddbfd', title: 'Diretivas' },
        { id: '70f73c08-9537-47d4-96ea-0d3e400ab072', title: 'Vue Router' },
        { id: '6ba041d8-1ea8-4cc0-b8ba-abad09f4fc04', title: 'Vuex' },
        { id: 'f6f6a11f-0c74-4915-9d2c-cd2591f827e4', title: 'Conclusão' }
      ]
    }
  ]
}
